import styled from "styled-components";

export const WrapperDocument = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 800px;

  .nav-section {
    width: 100%;
    display: grid;
  }

  .document-section {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
  }

  .title-document {
    display: flex;
    font-weight: 500;
    font-size: 10px;
    padding: 10px;
    justify-content: end;
    color: #0069c2;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }

  .title-section {
    padding: 10px 10px 30px 10px;
    font-size: 18px;
  }
  .icon-section {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px 30px 10px 30px;
    color: red;
  }

  .file-icon-section {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px 10px 3px 10px;
    /* color: red; */
  }

  .information-section {
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: bold;
    margin: 0px 10px 0px 10px;
    font-size: 11px;
    text-align: center;
  }

  .owner-section {
    font-weight: 500;
    font-size: 9px;
    margin-top: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .buttons-section {
    display: flex;
    flex-direction: row;
    padding: 20px;
    justify-content: space-between;
  }
  .buttons-group-section {
    display: flex;
    flex-direction: row;
    padding: 20px;
    justify-content: space-evenly;
  }
`;

export const ButtonCreate = styled.div`
  display: flex;
`;

export const WrapperButtons = styled.div`
  display: flex;
  margin: 30px 30px 0px 30px;
`;

